import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootState';
import { AttachmentPostInfo } from '../../../store/appState';
import styled from 'styled-components/macro';
import * as Actions from '../../../store/actions';
import { App } from '../../../app';
import Button from '../../shared/Button';

export interface ProfileAttachmentListProps {

}

export default function ProfileAttachmentList(): JSX.Element {
    const state = useSelector((state: RootState) => state.appState);

    const list = state.profileAttachments ?? [];

    const onAttachmentDownloadClick = (evt: React.MouseEvent, item: AttachmentPostInfo): void => {
        evt.preventDefault();
        App.telemetry.postBusinessEvent("downloadattachment-clicked", { filename: item.fileName });
        Actions.downloadAttachment(item);
    }

    return list && list.length !== 0 &&
        <Wrapper>
            {list.map((item, i) => (
                <Attachment key={i}>
                    <Button buttonType="link" size="compact" className="filename" onClick={(evt) => onAttachmentDownloadClick(evt, item)}>{App.StripAllHtml(item.fileName)}</Button>
                    {item.rootPostTypeName && <div className="info">
                        Attached to {item.postTypeName && item.postTypeName !== item.rootPostTypeName ? `${item.postTypeName} under ` : ''}the {item.rootPostTypeName}&nbsp;
                        <a className="problem" href={App.getTicketPath(item.rootPostId, item.rootPostTitle, true)} target="_blank" rel="noopener noreferrer">{App.StripAllHtml(item.rootPostTitle)}</a>
                    </div>}
                    <div className="info">
                        {`Added ${App.ParseDateTimeToLocal(item.createdDate)}`}
                    </div>
                </Attachment>
            ))}
        </Wrapper>
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    >* + * {
        margin-top: 1.5rem;
    }
`;

const Attachment = styled.article`
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    margin-left: 1.5rem;
    margin-right: 1.5rem;

    .info {
        color: var(--color-on-background-lighter);
    }

    .filename {
        cursor: pointer;
        font-weight: normal;
        font-size: var(--font-size-default);
        text-align: left;
    }
`;
